export default "__VITE_ASSET__CkR6orGX__"